/**
 * 环境配置文件
 */
import '@/env'

/**
 * 初始化
 */
import '@/bootstrap'

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import Vue from 'vue'
import App from './App.vue'
import store from '@store'

Vue.config.productionTip = false

/* eslint-disable no-new */
global.app = new Vue({
  router: Router,
  store,
  template: '<App/>',
  components: {App},
  computed: {
    ...Vuex.mapState({
      clientHeight: state => state.clientHeight,
    }),
    mainHeight () {
      return this.clientHeight - 50 - 21
    }
  },
})

global.mountApp = () => {
  global.app.$mount('#app')
}
if (process.env.NODE_ENV === 'production') {
  if (global.STYLE_READY) {
    global.mountApp()
  }
} else {
  global.mountApp()
}



// WEBPACK FOOTER //
// ./src/main.js